import SHA256 from 'crypto-js/sha256';

export function getUsernameFromPersonalNumber(personalNumber) {
  return `${SHA256(personalNumber)}`;
}
